module.exports = __webpack_public_path__ + "static/gq-spend-get-phase2-web-if-offers-banner-gemv-mobile-ce589fe74663ebbbc31db935022de2a8.png";